import React from "react";

const KIND_META: Record<string, { bg: string; color: string; border: string; label: string }> = {
  summarize: { bg: "var(--color-brand-ghost)", color: "var(--color-brand)", border: "color-mix(in srgb, var(--color-brand) 40%, transparent)", label: "SUMMARIZE" },   // violet
  tool:      { bg: "var(--color-success-ghost)", color: "var(--color-success)", border: "color-mix(in srgb, var(--color-success) 40%, transparent)", label: "TOOL" },        // emerald
  trend:     { bg: "var(--color-warning-ghost)", color: "var(--color-warning)", border: "color-mix(in srgb, var(--color-warning) 40%, transparent)", label: "TREND" },       // yellow
  agent:     { bg: "var(--color-danger-ghost)", color: "var(--color-danger)", border: "var(--color-danger-border)", label: "AGENT" },       // red
  prepare:   { bg: "var(--color-accent-ghost)", color: "var(--color-accent)", border: "color-mix(in srgb, var(--color-accent) 40%, transparent)", label: "PREPARE" },    // blue
};

export function kindLabel(kind?: string): string {
  const k = (kind || "").toLowerCase();
  return KIND_META[k]?.label ?? (k || "NONE").toUpperCase();
}

export function kindStyles(kind?: string): React.CSSProperties {
  const k = (kind || "").toLowerCase();
  const m =
    KIND_META[k] || { bg: "var(--color-subsurface)", color: "var(--color-ink)", border: "var(--color-border)", label: (k || "NONE").toUpperCase() };
  return {
    fontSize: 10.5,
    fontWeight: 800,
    color: m.color,
    background: m.bg,
    border: `1px solid ${m.border}`,
    borderRadius: 999,
    padding: "2px 8px",
    letterSpacing: 0.2,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
  };
}
